export default {
    init($){
        console.info('product.js: init');

        $('.single-product .product .summary form.cart').on('submit', function (e){
            let form = $(this);
            let submitButton = form.find('[type="submit"]');
            if (submitButton.length){
                submitButton.attr('data-text', submitButton.text());
                submitButton.text('Aguarde...');
                submitButton.addClass('disabled');
            }
        });

        // confirmação de produto adicionado ao carrinho
        let cartConfirmation = $('.cart-confirmation');
        let cartTimeout = null;
        let isMobile = window.matchMedia('(max-width:768px)').matches;

        $(document.body).on('added_to_cart', ()=>{
            cartConfirmation.addClass('show');
            if (!isMobile){
                clearTimeout(cartTimeout);
                cartTimeout = setTimeout(function(){
                    cartConfirmation.removeClass('show');
                }, 5000);
            }

        });

        cartConfirmation.on('click', '.cart-confirmation__close', function(e){
            e.preventDefault();
            cartConfirmation.removeClass('show');
        });


        // ajax add to cart in single product page

        $('.entry-summary form.cart').on('submit', function (e)
        {
            e.preventDefault();

            let btnSubmit = $('.entry-summary form.cart button[type=submit]');

            $('.entry-summary').block({
                message: null,
                overlayCSS: {
                    cursor: 'none'
                }
            });

            var product_url = window.location,
                form = $(this);

            let postData = form.serializeArray();

            postData.push({name: '_wp_http_referer', value: product_url});

            if (!$('input[name="add-to-cart"]').length){
                postData.push({name: 'add-to-cart', value: btnSubmit.val()});
            }

            $.post(product_url,  postData, function (result)
            {
                var cart_dropdown = $('.widget_shopping_cart', result);

                // update dropdown cart
                // $('.widget_shopping_cart').replaceWith(cart_dropdown);

                // update fragments

                $(document.body).trigger('added_to_cart');
                btnSubmit.text(btnSubmit.attr('data-text'));
                btnSubmit.removeClass('disabled');

                $('.entry-summary').unblock();

            });
        });

    }
}